import Swal from 'sweetalert2';
import 'animate.css';

export const SwalConfirmation = {
  triggerSwal: (title: string, text: string, confirmAction: () => void) => {
    Swal.fire({
      title: title || 'Are you sure?',
      text: text || 'Do you really want to continue?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Continue',
      cancelButtonText: 'Cancel',
      customClass: {
        container: 'fixed inset-0 z-50 overflow-y-auto bg-gray-900/50',  // Removed backdrop-blur-sm
        popup: 'relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl transform p-6 max-w-md mx-auto mt-16 animate__animated',
        title: 'text-2xl font-bold text-gray-800 dark:text-white mb-4',
        htmlContainer: 'text-gray-600 dark:text-gray-300 text-base mb-6',
        actions: 'flex gap-3 justify-end mt-6',
        confirmButton: 'px-6 py-2.5 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-all duration-150 ease-in-out transform hover:scale-105 animate__animated animate__fadeIn animate__faster',
        cancelButton: 'px-6 py-2.5 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 font-medium rounded-lg transition-all duration-150 ease-in-out transform hover:scale-105 animate__animated animate__fadeIn animate__faster',
      },
      showClass: {
        popup: 'animate__animated animate__zoomIn animate__faster',
        backdrop: 'swal2-backdrop-show animate__animated animate__fadeIn animate__faster'
      },
      hideClass: {
        popup: 'animate__animated animate__zoomOut animate__faster',
        backdrop: 'swal2-backdrop-hide animate__animated animate__fadeOut animate__faster'
      },
      backdrop: true,
      timer: undefined,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: true,
      allowEnterKey: true,
      focusConfirm: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise((resolve) => {
          setTimeout(resolve, 100); // Reduced further for quicker response
        });
      }
    }).then((result) => {
      if (result.isConfirmed) {
        confirmAction();
      }
    });
  }
};